import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { isEqual } from 'lodash-es';
import { resolveNestedValue, selectContext, selectValues } from '@icp/form-renderer-core';
import { useSelector } from '../../store/StoreProvider';
import { useCurrentData } from '../../currentDataCtx';

export default function useExtensionParams(extensionParams) {
  const params = useParams();
  const currentData = useCurrentData();
  const formData = useSelector(selectValues);
  const context = useSelector(selectContext);

  const newOne = resolveNestedValue({
    obj: extensionParams,
    currentData: currentData || formData,
    formData,
    context,
    params,
  });
  const last = useRef(newOne);

  const result = isEqual(last.current, newOne) ? last.current : newOne;
  last.current = newOne;
  return result;
}
